import {AxiosResponse} from 'axios';
import {host} from 'utils/constants';
import sendError from 'error-handler/functions/sendError';
import {blockedClientErrorCode} from 'error-handler/helper/utils';
import {Record} from 'utils/types';

interface Meta extends Record<string, any> {
  Function?: string;
  Component?: string;
  Line?: number;
  Author?: string;
  errorInfo?: string;
}

const middleware = async (callback: Function, metaInfo?: Meta): Promise<AxiosResponse> => {
  let result;

  try {
    result = await callback();
  } catch (err: any) {
    try {
      if (blockedClientErrorCode(err)) return err;
      await sendError({
        error: err,
        metaInfo: {
          ...metaInfo,
          errorInfo: `API middleware. ${metaInfo?.errorInfo}`,
        },
      });
    } catch (err) {
      console.warn(`Error: error sending to admin \n ${err}`);
    }

    if (host === 'loc') alert(`ERROR MIDDLEWARE: ${err}`);
  }
  return result;
};

export default middleware;
